import TaxPayer from './TaxPayer'
export default TaxPayer
